import { LayerManager } from './shared'
import { StoryAdBackdropLayerControls } from './story-ad-backdrop-layer-controls'
import { StoryAdContentLayerControls } from './story-ad-content-layer-controls'

export function StoryAdLayerManager() {
	return (
		<LayerManager
			contentLayerControls={<StoryAdContentLayerControls />}
			backdropLayerControls={<StoryAdBackdropLayerControls />}
		/>
	)
}
